import React, { useEffect } from "react";
import Button from "../Button";
import "./Permission.scss"; // Optional: If using external CSS

interface PermissionProps {
  name: string;
  image: string;
  text: string;
  cta: string;
  onClick: () => void;
  decodedParams?: any;
  uId?: string;
  posthogEvent?: any;
  clientConfig?: any;
}

const Permission: React.FC<PermissionProps> = ({
  name,
  image,
  text,
  cta,
  onClick,
  decodedParams,
  uId,
  posthogEvent,
  clientConfig,
}) => {
    useEffect(() => {
    posthogEvent.sendPostHogEvent('permission_screen_viewed', {
      permissionName: name,
      clientName: decodedParams?.clientName || null,
      source: decodedParams?.source || null,
      version: decodedParams?.version || null,
      deviceId: decodedParams?.deviceId || null,
      platform: decodedParams?.platform || null,
      model: decodedParams?.model || null,
      osVersion: decodedParams?.osVersion || null,
      env: decodedParams?.env || null,
      clientId: decodedParams?.clientId || uId,
      uId: decodedParams?.uId || uId,
    })
  }, [])
  const buttonColor = clientConfig?.primaryColor || '';
  return (
    <div
      className="PermissionWrapper"
      style={{ background: "white", backgroundSize: "cover" }}
    >
      <img src={image} alt={`${name} icon`} />
      <div className="PermissionName">{name}</div>
      <div className="PermissionText">{text}</div>
      <Button style={{ background: buttonColor }} onClick={() => onClick()} text={cta} />
    </div>
  );
};

export default Permission;
